import React from 'react';
import './GalleryAndTestimonials.css';

const GalleryAndTestimonials = () => {
  const galleryItems = [
    { image: 'https://www.mitsubishi-forklift.co.uk/hubfs/A_UK/Power%20Pallet%20Trucks/PREMIAESSBPN3-MINAPP-HIWEB-19-L.jpg', caption: 'Pallet Power' },
    { image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRdLk7k9eTUHDZI0-3L5LU-8KWLs8At4IrYUA&s', caption: 'Snack Stacks' },
    { image: 'https://hips.hearstapps.com/hmg-prod/images/screenshot-2024-08-15-at-3-08-00-pm-66be52fb7c32a.png?crop=1xw:1xh;center,top&resize=980:*', caption: 'Drinks Drop' },
    { image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT4GFpl97ZOJG5-RpAsxVN1re71PYFcwMsMyQ&s', caption: 'Rollin’ Bulk' },
    { image: 'https://images.unsplash.com/photo-1595854341625-f33ee10dbf94?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80', caption: 'Frozen Frenzy' },
  ];

  const testimonials = [
    { quote: 'KKP’s bulk drinks keep my shop buzzing—cheap, fast, and the punters love it!', author: 'Mick Jones', role: 'Shopkeeper, Leeds' },
    { quote: 'Snacks and cleaning gear in one haul—KKP’s prices mean I’m laughing to the bank.', author: 'Sara Ahmed', role: 'Market Trader, Bristol' },
    { quote: 'Pallet deals on frozen stuff? Sorted my cafe’s stock for weeks—top notch!', author: 'Tony Briggs', role: 'Cafe Owner, Glasgow' },
    { quote: 'Bulk toilet rolls and soaps—KKP’s got my stalls sorted with killer value.', author: 'Priya Singh', role: 'Vendor, London' },
  ];

  return (
    <section className="gallery-testimonial-section">
      <div className="gallery-testimonial-container">
        <div className="gallery">
          <h2 className="gallery-title">Our Warehouse</h2>
          <div className="gallery-stack">
            {galleryItems.map((item, index) => (
              <div key={index} className="gallery-item">
                <img src={item.image} alt={item.caption} className="gallery-image" />
                <span className="gallery-caption">{item.caption}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="testimonials">
          <h2 className="testimonial-title">Customer Feedback</h2>
          <div className="testimonial-stack">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="testimonial-card">
                <p className="testimonial-quote">{testimonial.quote}</p>
                <p className="testimonial-author">{testimonial.author}</p>
                <p className="testimonial-role">{testimonial.role}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default GalleryAndTestimonials;